import React from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import AppBar from '@mui/material/AppBar'
import Link from '@mui/material/Link'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import {styled} from '@mui/material'





// import Image from 'mui-image'
// import logo from './../../images/clinica_acor.png'

import { useUser } from '../../services/StateContext'
import { capitalizeWords, mascararCpf } from 'services/utils'
import { useLocation } from 'react-router-dom'
import { usePatient } from 'Components/usePatientContext'

const Item = styled(Typography)({
    fontSize: '12px',
    color: '#000',
})

const MainBox = styled(Box)({
    padding        : '10px 10px',
    borderRadius   : '0',
    minHeight      : '100%',
    backgroundColor: '#fff',
    display        : 'flex',
    flexDirection  : 'column',
})

const LinearProgessCustom = styled(LinearProgress)(({theme}) =>({
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200]
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: process.env.REACT_APP_BUTTON_STYLE_BG
    },
}))

const Head = ( ) => { 

    const business_name = process.env.REACT_APP_BUSINESS_NAME
    const logo          = require(process.env.REACT_APP_LOGO_PATH) 
    
    const { progress } = useUser()

    const { patient, userExists } = usePatient()

    const location = useLocation()
     
    // const name  = user.nomePaciente ? user.nomePaciente : user.nomePessoa
    // const sexoP = user.sexoPaciente ? user.sexoPaciente : user.sexo

    // const { firstName } = getSplitName(name)
    // const phrase = firstName ? "Paciente " + firstName : '' 
    // console.log(user, "USER")

    const TextHeader = () => {

        const style = {
            maxWidth: '160px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }

        if (
            [
                '/', '/cadastro', '/fim', '/obrigado', 
                '/central-agendamento', 
                '/particular-ou-convenio'
            ].includes(location.pathname)) {
            return null
        }
        
        const nomePaciente     = userExists ? patient?.nomePessoa : patient?.nomePaciente
        const hasNome          = nomePaciente !== '' && nomePaciente !== undefined
        const hasCpf           = patient?.cpfPaciente !== '' && patient?.cpfPaciente !== undefined
        const hasConvenio      = patient?.descricaoConvenio !== '' && patient?.descricaoConvenio !== undefined
        //const hasEspecialidade = user?.descricaoEspecialidade !== '' && user?.descricaoEspecialidade !== undefined

        const nome          = capitalizeWords(nomePaciente)
        const convenio      = capitalizeWords(patient?.descricaoConvenio)
        const cpfPaciente   = mascararCpf(patient?.cpfPaciente)
        //const especialidade = capitalizeWords(user.descricaoEspecialidade)
   
        return <MainBox 
            component={Paper} 
            elevation={1}
        >
            <Stack sx={{
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                minHeight: '54px',
            }}>    
                <>
                    {hasNome && <Item sx={style} variant="text.primary" >
                        Nome: { nome }
                    </Item>} 
                    {hasCpf && <Item variant="text.primary" >
                        CPF: {cpfPaciente}
                    </Item>}                
                
                    {hasConvenio && <Item sx={style} variant="text.primary" >
                        Convênio: {convenio}
                    </Item>}   
                </>
            </Stack>
            
        </MainBox>
    }

    const logoWidth = process.env.REACT_APP_LOGO_WIDTH 

    return (
        <Box>
            <AppBar position="static" color='transparent'>
                <Container>
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        textAlign: 'center',
                        justifyContent: 'space-between', 
                        minHeight: '77px'
                    }}>
                        <Link href={'/'} py={2} underline="none" >
                            <img width={logoWidth} src={logo} alt={`LOGO - ${business_name}`}/>
                        </Link>
                        
                        <TextHeader />
                    </Box>
                    
                </Container>
                <Box sx={{ width: '100%' }} >
                    
                    <LinearProgessCustom variant={"determinate"} value={progress} />
                </Box>
                
            </AppBar>
            
        </Box>
    ) 
}

export default Head